module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_sp_1000-92c4e34fc08aee9bd136a232915f85e4.png";